import { Component, OnInit } from '@angular/core';
import { BeasleyComponent } from '../beasley.component';
import { HeaderFieldComponent, CellFieldComponent, AttachmentLookupComponent } from '../../common/index';
import { AdminService, MetadataService, AuthService, ApiService, SessionService, ModalService, ConditionService } from '../../../services';
import { BeasleyService } from '../../../services/beasley/beasley.service';
import { Router } from '@angular/router';
import { ModalComponent } from '../../modal/modal.component';
import { Condition } from '../../../models';

@Component({
  selector: 'sn-bfp-claims',
  templateUrl: './bfp-claims.component.html',
  styleUrls: ['./bfp-claims.component.css', '../beasley.component.css']
})
export class BfpClaimsComponent extends BeasleyComponent {

    public items:Array<any> = [];  
    public columnFields:Array<any> = [];
    private viewConditions:Array<any> = [];
    view:string = this.beasleyService.view_bfp_claims;
    // search
    public searchText:string;
    // paging 
    public curPage:number = 1;
    public pageSize:number = 15;
    public pageCount:number = 0;
    public itemCount:number = 0;
    public orderBy: string = 'cs_case_number';
    public asc:boolean;
    protected conditionResults:Array<Condition> = [];

    constructor(
        private router: Router,
        public modalService: ModalService,
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public conditionService: ConditionService,
        public beasleyService: BeasleyService
    ) {
        super(adminService, metadataService, authService, apiService, sessionService, beasleyService);
        console.log('BfpClaimsComponent constructor');
    }

    ngOnInit() {
        super.ngOnInit();
        this.loadTableViewMetaData();

        // listen to searchText changes
        this.beasleyService.searchText.subscribe(
            value => {
                this.searchText = value;
                this.reloadItems(value);
            }
        );
        // listen to new claim creation
        this.beasleyService.newClaim.subscribe(
            value => {
                // reload to get the newly created claim
                this.reloadItems();
            }
        );
}

    loadTableViewMetaData() {
        console.log("loadMetaData");
        // column fields
        this.loadMetaData().subscribe(
            data => { 
                // wait till default meta data is load before laoding table view meta data
                this.sessionService.log("Default Meta Data Loaded", new Date());
                this.metadataService.getTableViewMetaData(this.view, { }, true).subscribe(result => {
                    console.log(result.meta_data.column_fields);
                    this.columnFields = result.meta_data.column_fields;
                    this.viewConditions = result.meta_data.view_conditions;
                    this.setActiveSortColumn(this.orderBy);
                    // load view items here after meta data is downloaded
                    this.reloadItems();
                });
            },
            err => { this.sessionService.log(err) }
        );
    }

    // gather all search params in json format to be used as request string parameter
    getSearchParams(executeScriptType:string = null) {
        var params:any = { }
        params.p = this.curPage;
        params.ps = this.pageSize;
        params.ob = this.orderBy;
        if (executeScriptType) params.est = executeScriptType;
        params.obd = this.asc ? "asc" : "desc";
        return params;
    }

    getExecuteScriptType(bSearchData:boolean = true, bTotalCount:boolean = true) {
        if (bSearchData && bTotalCount) return "ST_All";
        if (bSearchData) return "ST_Search";
        if (bTotalCount) return "ST_TotalCount";
    }
    
    reloadItems(searchText:string = null) {
        var params = this.getSearchParams(this.getExecuteScriptType(true, false));
        if (searchText) params.text = searchText;
        this.apiService.getViewData(this.view, params).subscribe(
            result => {
                result.items.forEach(i => {
                    var conditions = JSON.parse(JSON.stringify(this.viewConditions));                    
                    i.viewConditions = this.conditionService.evaluateItemValues(conditions, null, i);
                });
                this.items = result.items;
                console.log(this.items);
            },
            err => {
                console.log(err);
            }
        );
        var params = this.getSearchParams(this.getExecuteScriptType(false, true));
        if (searchText) params.text = searchText;
        this.apiService.getViewData(this.view, params).subscribe(
            result => {
                this.itemCount = result.total_count;
                this.pageCount =  Math.ceil(this.itemCount / this.pageSize);
            },
            err => {
                console.log(err);
            }
        );        
    }

    prevPage() {
        if (this.curPage > 1) {
            this.curPage--;
            this.reloadItems(this.searchText);
        }
    }

    nextPage() {
        if (this.curPage < this.pageCount) {
            this.curPage++;
            this.reloadItems(this.searchText);
        }
    }

    onFieldBtnEvent(btnEvent) {
        console.log(btnEvent);
        switch (btnEvent.btn.event)
        {
            case "sn_open_modal_view": this.openModalView(btnEvent); break;
            case "sn_open_modal_component": this.openModalComponent(btnEvent); break;
        }
    }

    openModalView(btnEvent) {
        var data = [];
        var view = "";
        switch (btnEvent.btn.modal_view) {
            case this.beasleyService.view_bfp_form_file_upload: 
                data = btnEvent.item;
                view = btnEvent.btn.modal_view;
                break;
        }

        this.modalService.openContent(
            ModalComponent,
            { view: view, data: data },
            { backdrop: 'static', keyboard: false }
        ).result.then((result) => {
                this.beasleyService.setNewClaim(result);
                this.sessionService.log(view + ' submitted');
            }, (reason) => {
                this.sessionService.log('Form Closed');
        })
    }

    openModalComponent(btnEvent) {
        switch (btnEvent.btn.modal_component) {
            case "sn-usc-attachment-lookup": this.showAttachments(btnEvent.item); break;
        }
    }

    showAttachments(item) {
        this.modalService.openContent(
            AttachmentLookupComponent,
            { view: this.view, data: item, related_type: "case", related_ID: item.view_ID, title: "Attachments - Claim #" + item.cs_case_number },
            { size: "lg", backdrop: 'static', keyboard: false }
        ).result.then((result) => {
          console.log(result);
        }, (reason) => {
          console.log('Attachment Closed');
        });
    }

    onColumnSort(event) {
        // default to asc = true if switching to a different column, else flip the currect sort state
        this.asc = event.field.key != this.orderBy ? true : !this.asc;
        this.orderBy = event.field.key;
        this.setActiveSortColumn(event.field.key);
        this.reloadItems();
    }

    setActiveSortColumn(column_key:string) {
        for (var i = 0; i < this.columnFields.length; i++) {
            var field = this.columnFields[i];
            field.sort_active = (field.key == column_key);
        }
    }
        
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/beasley/bfp-claims/bfp-claims.component.ts